import React, { useEffect, useState } from "react";

function NetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };

    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const handleManualReload = () => {
    window.location.reload();
  };

  if (isOnline) return null;

  return (
    <div style={styles.container}>
      <span>You are offline. Please check your internet connection.</span>
      <button onClick={handleManualReload} style={styles.button}>
        Retry
      </button>
    </div>
  );
}

const styles = {
  container: {
    position: "fixed",
    top: 0,
    width: "100%",
    backgroundColor: "#d32f2f",
    color: "#fff",
    textAlign: "center",
    padding: "10px",
    zIndex: 2000,
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    alignItems: "center",
  },
  button: {
    background: "#fff",
    color: "#d32f2f",
    border: "none",
    padding: "4px 10px",
    borderRadius: "4px",
    cursor: "pointer",
    fontWeight: "bold",
  },
};

export default NetworkStatus;
